import { Link } from 'react-router-dom';
import ProtectedAdminRoute from '../../components/ProtectedAdminRoute';
import '../../styles/admin/AdminDashboard.css';

export default function AdminDashboard() {
  return (
    <ProtectedAdminRoute>
      <div className="admin-dashboard">
        <div className="admin-page-header">
          <h1 className="admin-page-title">Admin Dashboard</h1>
          <p className="admin-page-subtitle">Manage projects, members, and resources</p>
        </div>
        <div className="admin-sections">
          {/* Directly render admin sections, no loading/error logic needed */}
          <>
            <div className="admin-section">
              <div className="section-header">
                <h3>Project Groups</h3>
                <p>Create and manage project groups and subgroups</p>
              </div>
              <div className="section-actions">
                <Link to="/admin/project-groups/add" className="action-btn primary">
                  <span className="btn-icon">+</span>
                  Add Project Group
                </Link>
                <Link to="/admin/project-groups/edit" className="action-btn secondary">
                  <span className="btn-icon">Edit</span>
                  Edit Project Groups
                </Link>
              </div>
            </div>

            <div className="admin-section">
              <div className="section-header">
                <h3>Projects</h3>
                <p>Manage research projects and publications</p>
              </div>
              <div className="section-actions">
                <Link to="/admin/add-project" className="action-btn primary">
                  <span className="btn-icon">+</span>
                  Add Project
                </Link>
                <Link to="/admin/edit-project" className="action-btn secondary">
                  <span className="btn-icon">Edit</span>
                  Edit Project
                </Link>
              </div>
            </div>

            <div className="admin-section">
              <div className="section-header">
                <h3>Team Members</h3>
                <p>Manage team member profiles and information</p>
              </div>
              <div className="section-actions">
                <Link to="/admin/add-member" className="action-btn primary">
                  <span className="btn-icon">+</span>
                  Add Member
                </Link>
                <Link to="/admin/edit-member" className="action-btn secondary">
                  <span className="btn-icon">Edit</span>
                  Edit Member
                </Link>
              </div>
            </div>

            <div className="admin-section">
              <div className="section-header">
                <h3>Resources</h3>
                <p>Manage educational resources and tools</p>
              </div>
              <div className="section-actions">
                <Link to="/admin/resources/add" className="action-btn primary">
                  <span className="btn-icon">+</span>
                  Add Resource
                </Link>
                <Link to="/admin/resources/edit" className="action-btn secondary">
                  <span className="btn-icon">Edit</span>
                  Edit Resource
                </Link>
              </div>
            </div>

            <div className="admin-section">
              <div className="section-header">
                <h3>Contact & Messages</h3>
                <p>View and manage contact form submissions</p>
              </div>
              <div className="section-actions">
                <Link to="/admin/messages" className="action-btn primary full-width">
                  <span className="btn-icon">View</span>
                  View Messages
                </Link>
              </div>
            </div>

            <div className="admin-section">
              <div className="section-header">
                <h3>Team Settings</h3>
                <p>Manage team page content and images</p>
              </div>
              <div className="section-actions">
                <Link to="/admin/edit-team-image" className="action-btn primary full-width">
                  <span className="btn-icon">Edit</span>
                  Edit Team Image
                </Link>
              </div>
            </div>

            <div className="admin-section">
              <div className="section-header">
                <h3>Recruitment</h3>
                <p>Manage recruitment status and application form</p>
              </div>
              <div className="section-actions">
                <Link to="/admin/recruitment" className="action-btn primary full-width">
                  <span className="btn-icon">⚙️</span>
                  Recruitment Settings
                </Link>
              </div>
            </div>

            <div className="admin-section">
              <div className="section-header">
                <h3>Quant Club</h3>
                <p>Manage Quant Club activities, members, and events</p>
              </div>
              <div className="section-actions">
                <Link to="/admin/quant-club/edit" className="action-btn secondary">
                  <span className="btn-icon">Edit</span>
                  Edit Quant Club
                </Link>
              </div>
            </div>
          </>
        </div>
      </div>
    </ProtectedAdminRoute>
  );
}